<template>
	<div class="">
        <template v-if="create_payroll_batch == true">

            <div class="modal fade" id="needAttention" tabindex="-1" aria-labelledby="needAttention" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body fields-map-popup">
                            <div class="popup-head mb-4">
                                <h2 class="pb-0"> Need your attention. </h2>
                                <p> Please, add or map them all. </p>
                            </div>
                            <div class="need-attention-content">
                            </div>
                            <div class="mt-4 text-right">
                                <button type="button" class="btn btn-primary" id="popupProcessButton">Proceed</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addDepartment" tabindex="-1" aria-labelledby="addDepartment" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            We've found some new department
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Department  </h2>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" id="departmentAddValue" />
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveDepartment()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addCategory" tabindex="-1" aria-labelledby="addCategory" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Category  </h2>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" id="categoryAddValue" />
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveCategory()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addCity" tabindex="-1" aria-labelledby="addCity" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add City  </h2>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" id="cityAddValue" />
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveCity()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addBranch" tabindex="-1" aria-labelledby="addBranch" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Branch  </h2>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" id="branchAddValue" />
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveBranch()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <div class="clearfix">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> Create Payment Batch </h1>
                    <div class="progress-bar-holder">
                        <div class="progress step-one">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <ul class="prgress-number">
                            <li class="progress-number-list active">
						<span class="bullet">
							1
						</span>
                                <p> Upload </p>
                            </li>
                            <li class="progress-number-list" id="progressNumberListTwo">
						<span class="bullet">
							2
						</span>
                                <p> Field Mapping </p>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-primary float-right mr-1" id="process_dropzone_queue" v-show="proceedButtonflag" @click="processDisabled = true" :disabled="processDisabled == true"> Proceed </button>
                    <router-link class="btn btn-primary float-right mr-1" to="/employeePayments"> Cancel </router-link>
                </div>
                <div class="batch-upload-main">
                    <div class="batch-upload-inner">
                        <div class="upload-sheet" v-show="previewMapField == false">
                            <div class="form-group">
                                <input type="text" placeholder="What would you like to call this batch?" class="form-control" v-model="title" @change="handleGeneratePayrollButton()" />
                            </div>
                            <div class="row align-items-center new-batch-payroll-type mb-4">
                                <div class="col">
                                    <label class="label block-label"> Payroll Type <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Disbursement CSV run for one time or for a period of time."></i>
                                    </label>
                                </div>
                                <div class="col">
                                    <label class="radio-holder">
                                        Full Payroll
                                        <input type="radio" v-model="payroll_type" value="PAYROLL" checked @change="handleGeneratePayrollButton()">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col">
                                    <label class="radio-holder">
                                        Partial Payroll
                                        <input type="radio" v-model="payroll_type" value="PARTIAL_PAYROLL" @change="handleGeneratePayrollButton()">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col">
                                    <label class="radio-holder">
                                        Commission
                                        <input type="radio" v-model="payroll_type" value="COMMISSION" @change="handleGeneratePayrollButton()">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col">
                                    <label class="radio-holder">
                                        Reimbursement
                                        <input type="radio" v-model="payroll_type" value="REIMBURSEMENT" @change="handleGeneratePayrollButton()">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="row align-items-center new-batch-payroll-type mb-4">
                                <div class="col-3">
                                    <label for="" class="label block-label"> Payment Type <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Disbursement CSV run for one time or for a period of time."></i>
                                    </label>
                                </div>
                                <div class="col-3">
                                    <label class="radio-holder">
                                        For a period
                                        <input type="radio" v-model="payroll_frequency" checked value="TIMEPERIOD" @change="handleGeneratePayrollButton()">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div class="col-3">
                                    <label class="radio-holder">
                                        One time
                                        <input type="radio" v-model="payroll_frequency" value="ONETIME" @change="handleGeneratePayrollButton()">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>

                            </div>
                            <label for="" class="label block-label mb-4"> Payroll Period <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="This is a period against which a payment is made to employees, vendors or any other person."></i>
                            </label>
                            <div class="row mb-4">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <datepicker  @selected="handleGeneratePayrollButton()" @input="from_date = fixDate($event)" :disabledDates="disabledDates" v-model="from_date" input-class="datepicker" placeholder="From" :bootstrap-styling="true" v-show="payroll_frequency == 'TIMEPERIOD'"></datepicker>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <datepicker  @selected="handleGeneratePayrollButton()" @input="to_date = fixDate($event)" :disabledDates="disabledDates" v-model="to_date" placeholder="To" input-class="datepicker" :bootstrap-styling="true" v-show="payroll_frequency == 'TIMEPERIOD'"></datepicker>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <datepicker  @selected="handleGeneratePayrollButton()" @input="onetime_date = fixDate($event)" :disabledDates="disabledDates" v-model="onetime_date" placeholder="Onetime" input-class="datepicker" :bootstrap-styling="true" v-show="payroll_frequency == 'ONETIME'"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <label for="" class="label block-label upload-label"> Upload a CSV <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title=".CSV is an Microsoft Excel file format which is a requirement for Finja Business to read your file. You can save your Excel file into a .CSV file using 'save as' option listed under file menu on your Excel program."></i>
                            </label>
                            <p v-show="$global.user_company_payment_engine != 'FAYSAL'">Download a bank code template <a :href="`${$global.base_url}csv/BankCode`" target="_blank">here.</a> </p>
                            <p> Download a sample template <a :href="`${$global.aws_base_url}/csv/Payroll.csv`">here</a>. </p>
                            <form  method="post" class="box dropzone drozone-label dz-clickable dropzone content mt-4" action="/upload" id="drop" data-toggle="tooltip" data-placement="left" title="<p class='align-left'>Your CSV file must have the following in order to upload employees in bulk: <br/>
                            1. No repetitions of column names.<br/>
                            2. Only add registered mobile numbers.<br/>
                            3. Mobile numbers (Wallet numbers) must be in the following format: 923XXXXXXXXX.<br/>
                            4. No special characters in the sheet.<br/>
                            5. Set the formatting of the mobile number column to 'number' with zero decimal places.<br/>
                            6. There should be no empty cells in a valid row.<br/>
                            7. Name, Mobile Number, Basic Salary, Gross Salary, Date of Joining, Email Address and Employment Status are required to upload a batch.</p>">
                                <div class="box__input dz-message">
                                    <label class="drozone-label" for="file">
                                        <img  id="uploadIcon" for="file" src="/images/svgs/upload-icon.svg" alt="" class="upload">
                                        <span for="file" class="filename"> Drop your file here </span>
                                    </label>
                                    <label class="uploadedFileName">Drop your file here</label>
                                </div>
                                <div class="disable-click" style="display: none;">
                                    <a class="cross" href="javascript:void(0)"><img style="cursor:pointer;" src="/images/cross.png" alt="Remove File" title="Remove File" /></a>
                                </div>
                            </form>
                            <em class="dropzone-or"> Or </em> <label id="selectFromComputer" class="btn btn-primary select-file-btn"> Select from your computer </label>

                        </div> <!-- upload sheet -->

                        <div class="previewMapField" v-show="previewMapField == true">
                            <div class="mandatory-fields mb-4">
                                <label for="" class="label block-label upload-label mb-3"> Mandatory Information <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="These fields are required for Finja Business to process your sheet."></i> </label>
                                <div class="mandatory-tags">
                                    <div class="mandatory-fields-inner">
                                        <div class="mandatory-field-col"> <span class="map-value" title="Mobile Number"> <i v-show="mand_mobile_number == true" class="fas fa-check"></i> Mobile Number </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Income Tax"> <i v-show="mand_tax == true" class="fas fa-check"></i> Income Tax </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Basic Salary"> <i v-show="mand_basic_salary == true" class="fas fa-check"></i> Basic Salary </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Net Payable"> <i v-show="mand_net_payable == true" class="fas fa-check"></i> Net Payable </span> </div>
                                    </div>
                                </div>
                            </div>
                            <label for="" class="label block-label upload-label"> Preview and map your identifiers <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Please review the below identifiers in line with the columns in your sheet."></i>
                            </label>
                            <p> Please check if we have correctly picked your data. </p>
                            <div class="fields-mapping mt-4" id="fieldmapping_table">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="create_payroll_batch === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="create_payroll_batch === false">
            <notAllowed></notAllowed>
        </template>
	</div>
</template>


<script>
    export default {
        data() {
            return {
                create_payroll_batch : true,
                previewMapField : false,
                mand_name : false,
                mand_father_name : false,
                mand_email : false,
                mand_cnic : false,
                mand_mobile_number : false,
                mand_account_type : false,
                mand_bank_code : false,
                mand_account_number : false,
                mand_dob : false,
                mand_doj : false,
                mand_description : false,
                mand_department : false,
                mand_branch : false,
                mand_city : false,
                mand_category : false,
                mand_basic_salary : false,
                mand_net_payable : false,
                mand_address : false,
                mand_tax : false,
                mand_filer : false,
                mand_ntn : false,
                fileAdded : false,
                filecolumn : [],
                fileRowData : [],
                departmentCount : 0,
                departmentMapped : 0,
                branchCount : 0,
                branchMapped : 0,
                cityCount : 0,
                cityMapped : 0,
                categoryCount : 0,
                categoryMapped : 0,
                departmentLi : [],
                branchLi : [],
                cityLi :[],
                categoryLi : [],
                finalDepartmentArray : [],
                finalcategoryArray : [],
                finalcityArray : [],
                finalBranchArray : [],
                dropZoneObject : null,
                proceedButtonflag : false,
                title : '',
                payroll_id : '',
                payroll_type : 'PAYROLL',
                payroll_frequency : 'ONETIME',
                from_date : '',
                to_date : '',
                onetime_date : '',
                companyType : '',
                company : '',
                payroll : '',
                payrollType: '',
                departments : '',
                branches: '',
                cities: '',
                processDisabled: false,
                disabledDates: {
                    from: new Date(Date.now())
                },
            }
        },
        methods: {
            fixDate(event){
                return moment(event).format('YYYY-MM-DD');
            },
            processDropzoneQueue(){

            },
            handleGeneratePayrollButton(){
                var flag = false;
                if(this.payroll_type == 'PAYROLL' || this.payroll_type == 'PARTIAL_PAYROLL' || this.payroll_type == 'COMMISSION' || this.payroll_type == 'REIMBURSEMENT'){
                    if(this.payroll_frequency == 'TIMEPERIOD' && this.from_date != '' && this.to_date != ''){
                        flag = true;
                    }
                    if(this.payroll_frequency == 'ONETIME' && this.onetime_date != ''){
                        flag = true;
                    }
                }
                if(flag == true && this.fileAdded == true){
                    if(this.isAPIAvailable()){
                        $.when(this.printTable(this.dropZoneObject.files[0]));
                    }
                }else{
                    if(this.fileAdded == true){
                        this.showToastBox('warning','Please select all values');
                    }
                }
            },
            initDropZone() {
                var that = this;
                Dropzone.options.drop = {
                    timeout:0,
                    addRemoveLinks: true,
                    paramName: 'file',
                    maxFilesize: 2, // MB
                    uploadMultiple: false,
                    maxFiles: 1,
                    minFiles: 1,
                    queueLimit:1,
                    url: that.$global.base_url+'api/paymentBulkUpload',
                    acceptedFiles: '.csv',
                    autoProcessQueue:false,
                    headers: window.axios.defaults.headers.common,
                    init: function(){
                        var _this = this;
                        that.dropZoneObject = this;
                        var selectedFile = document.getElementById('selectFromComputer');
                        selectedFile.addEventListener('click',function(){
                            _this.hiddenFileInput.click();
                        });
                        this.on("maxfilesexceeded", function(file) {
                            this.removeAllFiles();
                            this.addFile(file);
                        });
                        this.on('removedfile',function(file){
                            that.fileAdded = false;
                            $('div.box__input').show();
                        }),
                        this.on("addedfile", function(file) {
                            var ext = file.name.split('.')[1];
                            var invalid = 0;
                            if(ext != 'csv'){
                                that.showToastBox('error','Invalid file added');
                                this.removeFile(file);
                                return false;
                            }
                            that.fileAdded = true;
                            that.checkFileForErrors(file);
                            $('label.uploadedFileName').html(file.name);
                            $('.disable-click').show();
                            that.handleGeneratePayrollButton();
                        });
                        var submitButton_top 	= document.querySelector("#process_dropzone_queue");
                        var popupProcessButton 	= document.querySelector("#popupProcessButton");
                        function processFileLocal(){
                            if(that.isAPIAvailable()){
                                $.when(that.printTable(that.dropZoneObject.files[0]));
                            }
                        }
                        function processQueueLocal(){
                            if(
                                (that.departmentCount > 0 && that.departmentCount != that.departmentMapped) || //Department Count
                                (that.branchCount > 0 && that.branchCount != that.branchMapped) || //Branch Count
                                (that.cityCount > 0 && that.cityCount != that.cityMapped)  //City Count
                            ){
                                if($("#needAttention").hasClass('in')){
                                    that.showToastBox('error','Please either add them or associate them with exisiting ones.')
                                }else{
                                    $("#needAttention").modal("show");
                                }
                            }else{
                                that.dropZoneObject.processQueue(); // Tell Dropzone to process all queued files.
                            }
                        }
                        submitButton_top.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        popupProcessButton.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        that.dropZoneObject.on("sending", function(file, xhr, formData) {
                            that.$Progress.start();
                            var departmentNames = [];
                            var departmentids = [];

                            var categoryNames = [];
                            var categoryids = [];

                            var cityNames = [];
                            var cityids = [];

                            var branchNames = [];
                            var branchids = [];

                            that.finalDepartmentArray.forEach(dept => {
                                departmentNames.push(dept.name);
                                departmentids.push(dept.id);
                            });

                            that.finalcategoryArray.forEach(cat => {
                                categoryNames.push(cat.name);
                                categoryids.push(cat.id);
                            });

                            that.finalcityArray.forEach(city => {
                                cityNames.push(city.name);
                                cityids.push(city.id);
                            });

                            that.finalBranchArray.forEach(branch => {
                                branchNames.push(branch.name);
                                branchids.push(branch.id);
                            });
                            // Will send the filesize along with the file as POST data.
                            formData.append("departmentNames", JSON.stringify(departmentNames));
                            formData.append("departmentids", JSON.stringify(departmentids));
                            formData.append("categoryNames", JSON.stringify(categoryNames));
                            formData.append("categoryids", JSON.stringify(categoryids));
                            formData.append("cityNames", JSON.stringify(cityNames));
                            formData.append("cityids", JSON.stringify(cityids));
                            formData.append("branchNames", JSON.stringify(branchNames));
                            formData.append("branchids", JSON.stringify(branchids));
                            formData.append("filesize", file.size);
                            var mapIdentifier = [];
                            var selVal = '';
                            $( "select.selectpicker" ).each(function() {
                                selVal = $(this).find('option:selected').val();
                                mapIdentifier.push(selVal);
                                selVal = '';
                            });
                            formData.append("mapIdentifier", JSON.stringify(mapIdentifier));
                            formData.append("_token",$('meta[name="csrf-token"]').attr('content'));
                            formData.append("payroll_type", that.payroll_type);
                            formData.append("payroll_frequency", that.payroll_frequency);
                            formData.append("from_date", that.from_date);
                            formData.append("to_date", that.to_date);
                            formData.append("onetime_date", that.onetime_date);
                            formData.append("sheetName", that.title);
                            formData.append("payroll_id", that.payroll_id);
                            formData.append("title", that.title);
                            var payrollType =  that.payroll_type;
                            var mapIdentifier = [];
                            var selVal = '';
                            $( "select.selectpicker.mapping" ).each(function() {
                                selVal = $(this).find('option:selected').val();
                                mapIdentifier.push(selVal);
                                selVal = '';
                            });

                        });

                        that.dropZoneObject.on("totaluploadprogress", function(progress) {

                        });

                        that.dropZoneObject.on("uploadprogress", function(file, progress, bytesSent) {
                            // Update progress bar with the value in the variable "progress", which
                            // is the % total upload progress from 0 to 100
                            var progressBar = Math.floor(progress);
                            if(progressBar == 100){
                                that.$Progress.finish();
                            }
                        });

                        that.dropZoneObject.on("success", function(file, obj) {
                            var msg = null;
                            if(obj.code == "200") {
                                that.showToastBox('success','Employee Payments uploaded successfully');
                                that.$router.push('/employeePayments');
                            }else if(obj.code == "2"){
                                msg = obj.message;
                            }else if(obj.code == "301"){
                                msg = obj.message;
                            }else{
                                msg = obj.message;
                            }
                            if(msg !== null){
                                that.showAlertBox('error','Error in file',msg, 700);
                            }
                        });

                        that.dropZoneObject.on('error',function(file,errorMessage,xhr){
                            if(!file.accepted){
                                that.fileAdded = false;
                                var error_message = $('div#wrongfilemessage').html();
                                that.showAlertBox('error','Error in file',error_message);
                                this.removeFile(file);
                            }
                            var msg = '<strong>Error:'+xhr.status+'</strong> '+xhr.statusText;
                            that.showAlertBox('error','Error in file', msg);
                            file.status = Dropzone.QUEUED;
                        });

                    }


                };
                $('.cross').on('click', function(e){
                    that.dropZoneObject.removeAllFiles();
                    $('.disable-click').hide();
                    $('label.uploadedFileName').html('Drop your file here');
                });
            },
            isAPIAvailable() {
                // Check for the various File API support.
                if (window.File && window.FileReader && window.FileList && window.Blob) {
                    // Great success! All the File APIs are supported.
                    return true;
                } else {
                    var error_message = 'The HTML5 APIs used in this form are only available in the following browsers:<br /> - Google Chrome: 13.0 or later<br /> - Mozilla Firefox: 6.0 or later<br /> - Internet Explorer: Not supported (partial support expected in 10.0)<br /> - Safari: Not supported<br /> - Opera: Not supported';
                    this.showAlertBox('error',error_message);
                    return false;
                }
            },
            printTable(file) {
                this.$Progress.start();
                var deptRowid = 0;
                var categoryRowid = 0;
                var cityRowid = 0;
                var branchRowid = 0;
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    for(var row in data){
                        if(row > 0){
                            var _row = [];
                            if(data[row] != ""){
                                for(var item in data[row]){
                                    var value = data[row][item];
                                    _row.push(value);
                                }
                                that.fileRowData.push(_row);
                            }
                        }
                    }
                    var test 		= '';
                    var selected 	= '';
                    var col = [];
                    for(var row in data) {
                        if(row > 1) break;
                        for(var item in data[row]) {
                            if(row == 0){
                                col[item] = [data[row][item]];
                            }else{
                                col[item].push(data[row][item]);
                            }
                        }
                    }
                    for(var row1 in col) {
                        var rowName = '';
                        var rowValue = '';
                        var comboBox = '';
                        var fieldMap = false;
                        for(var item1 in col[row1]) {
                            if(item1 > 1){ break; }
                            if(item1 == 0){
                                rowName = col[row1][item1];
                            }else{
                                rowValue += '<p>' + col[row1][item1] + '</p>';
                            }
                        }
                        // check for if you find the Name in you ddList
                        if(rowName.trim().toLocaleLowerCase() == 'name'){
                            that.mand_name = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'mobile number'){
                            that.mand_mobile_number = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'account type'){
                            that.mand_account_type = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'bank code'){
                            that.mand_bank_code = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'account number'){
                            that.mand_account_number = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'department'){
                            that.mand_department = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'branch'){
                            that.mand_branch = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'city'){
                            that.mand_city = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'category'){
                            that.mand_category = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'income tax'){
                            that.mand_tax = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'basic salary'){
                            that.mand_basic_salary = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'net payable'){
                            that.mand_net_payable = fieldMap = true;
                        }
                        comboBox += '<select name="'+row1+'" class="selectpicker show-menu-arrow custom-select2" data-size="6">';
                        comboBox += '<option value="do-not"> - Select - </option>';
                        comboBox += '<optgroup label="Mobile Number">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? true : fieldMap;
                        comboBox += '<option value="Mobile number" '+selected+'>Mobile number</option>';
                        comboBox += '</optgroup>';
                        comboBox += '<optgroup label="Gross Salary">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'basic salary') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'basic salary') ? true : fieldMap;
                        comboBox += '	<option value="Basic Salary" '+selected+'>Basic Salary</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'housing allowance') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'housing allowance') ? true : fieldMap;
                        comboBox += '	<option value="Housing Allowance" '+selected+'>Housing Allowance</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'medical allowance') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'medical allowance') ? true : fieldMap;
                        comboBox += '	<option value="Medical Allowance" '+selected+'>Medical Allowance</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'car allowance') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'car allowance') ? true : fieldMap;
                        comboBox += '	<option value="Car Allowance" '+selected+'>Car Allowance</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'fuel allowance') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'fuel allowance') ? true : fieldMap;
                        comboBox += '	<option value="Fuel Allowance" '+selected+'>Fuel Allowance</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'other allowance') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'other allowance') ? true : fieldMap;
                        comboBox += '	<option value="Other Allowance" '+selected+'>Other Allowance</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'overtime') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'overtime') ? true : fieldMap;
                        comboBox += '	<option value="Overtime" '+selected+'>Overtime</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'bonus') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'bonus') ? true : fieldMap;
                        comboBox += '	<option value="Bonus" '+selected+'>Bonus</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'commission') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'commission') ? true : fieldMap;
                        comboBox += '	<option value="Commission" '+selected+'>Commission</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'conveyance') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'conveyance') ? true : fieldMap;
                        comboBox += '	<option value="Conveyance" '+selected+'>Conveyance</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'other additional earning') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'other additional earning') ? true : fieldMap;
                        comboBox += '	<option value="Other Additional Earning" '+selected+'>Other Additional Earning</option>';
                        comboBox += '	</optgroup>';
                        comboBox += '	<optgroup label="Reimbursements">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'reimbursements') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'reimbursements') ? true : fieldMap;
                        comboBox += '	<option value="Reimbursements" '+selected+'>Other Reimbursements</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'fuel reimbursement') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'fuel reimbursement') ? true : fieldMap;
                        comboBox += '	<option value="Fuel Reimbursement" '+selected+'>Fuel Reimbursement</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'traveling reimbursement') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'traveling reimbursement') ? true : fieldMap;
                        comboBox += '	<option value="Traveling Reimbursement" '+selected+'>Traveling Reimbursement</option>';
                        comboBox += '	</optgroup>';
                        comboBox += '	<optgroup label="Deductions">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'eobi') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'eobi') ? true : fieldMap;
                        comboBox += '	<option value="EOBI" '+selected+'>EOBI</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'provident fund') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'provident fund') ? true : fieldMap;
                        comboBox += '	<option value="Provident Fund" '+selected+'>Provident Fund</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'other deductions') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'other deductions') ? true : fieldMap;
                        comboBox += '	<option value="Other Deductions" '+selected+'>Other Deductions</option>';
                        comboBox += '	</optgroup>';
                        comboBox += '	<optgroup label="Tax">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'income tax') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'income tax') ? true : fieldMap;
                        comboBox += '	<option value="Income Tax" '+selected+'>Income Tax</option>';
                        comboBox += '	</optgroup>';
                        
                        comboBox += '	<optgroup label="Additionals">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'utility') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'utility') ? true : fieldMap;
                        comboBox += '	<option value="Utility" '+selected+'>Utility</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'cola') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'cola') ? true : fieldMap;
                        comboBox += '	<option value="Cola" '+selected+'>Cola</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'one time') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'one time') ? true : fieldMap;
                        comboBox += '	<option value="One Time" '+selected+'>One Time</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'advances') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'advances') ? true : fieldMap;
                        comboBox += '	<option value="Advances" '+selected+'>Advances</option>';
                        comboBox += '	</optgroup>';
                        comboBox += '	<optgroup label="Net Payable">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'net payable') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'net payable') ? true : fieldMap;
                        comboBox += '	<option value="Net Payable" '+selected+'>Net Payable</option>';
                        comboBox += '	</optgroup>';
                        comboBox +=	'<optgroup label="For New Joiners Only">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'name') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'name') ? true : fieldMap;
                        comboBox += '<option value="Name" '+selected+'>Name</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'cnic') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'cnic') ? true : fieldMap;
                        comboBox += '<option value="CNIC" '+selected+'>CNIC</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'email') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'email') ? true : fieldMap;
                        comboBox += '<option value="Email" '+selected+'>Email</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'department') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'department') ? true : fieldMap;
                        comboBox += '<option value="Department" '+selected+'>Department</option>';
                        if(selected == "selected"){
                            deptRowid = row1;
                        }
                        selected = (rowName.trim().toLocaleLowerCase() == 'date of joining') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'date of joining') ? true : fieldMap;
                        comboBox += '<option value="Date Of Joining" '+selected+'>Date Of Joining</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'branch') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'branch') ? true : fieldMap;
                        comboBox += '<option value="Branch" '+selected+'>Branch</option>';
                        if(selected == 'selected'){
                            branchRowid = row1;
                        }
                        selected = (rowName.trim().toLocaleLowerCase() == 'city') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'city') ? true : fieldMap;
                        comboBox += '<option value="City" '+selected+'>City</option>';
                        if(selected == 'selected'){
                            cityRowid = row1;
                        }
                        comboBox += '</optgroup>';
                        comboBox += '</select>';
                        if(fieldMap == true){
                            test += '<div class="row mapped align-items-center">';
                        }else{
                            test += '<div class="row align-items-center">';
                        }
                        test += '<div class="col-md-1"><div class="fields-mapping-inner"><i class="fas fa-check-circle"></i></div></div>';
                        test += '<div class="col-md-7"><div class="fields-mapping-inner"><p> '+rowName+' </p><p> '+rowValue+' </p></div></div>';
                        test += '<div class="col-md-4"><div class="fields-mapping-inner">';
                        test += comboBox;
                        test += '</div></div>';
                        test += '</div>';
                    }
                    $('#fieldmapping_table').html(test);
                    that.previewMapField = true;
                    that.generateButtonProccess();
                    $('select.selectpicker').selectpicker('refresh');
                    that.assignComboFunction();
                    if(deptRowid != 0){
                        that.showFieldInIdentifiers('department',that.fileRowData,deptRowid);
                    }
                    if(categoryRowid != 0){
                        that.showFieldInIdentifiers('category',that.fileRowData,categoryRowid);
                    }
                    if(cityRowid != 0){
                        that.showFieldInIdentifiers('city',that.fileRowData,cityRowid);
                    }
                    if(branchRowid != 0){
                        that.showFieldInIdentifiers('branch',that.fileRowData,branchRowid);
                    }
                    $('div.progress').addClass('step-two');
                };
                reader.onerror = function(){ this.showAlertBox('error','Unable to read ' + file.fileName); }.bind(this);
                this.$Progress.finish();
            },
            generateButtonProccess(){
                if(this.mand_mobile_number == true && this.mand_tax == true && this.mand_basic_salary == true && this.mand_net_payable == true){
                    this.proceedButtonflag = true;
                }else{
                    this.proceedButtonflag = false;
                }
            },
            checkForMandField(){
                var that = this;
                $( "select.selectpicker" ).each(function(index,value) {
                    if(index == 0){
                        that.mand_mobile_number = that.mand_tax = that.mand_basic_salary = that.mand_net_payable = false;
                    }
                    var selVal = $(this).find('option:selected').val();
                    if(selVal !== 'do-not'){
                        $(this).parent().parent().parent().parent().addClass('mapped');
                    }
                    if(selVal.trim().toLowerCase() == 'mobile number') that.mand_mobile_number = true;
                    /*if(selVal.trim().toLowerCase() == 'bank code') that.mand_bank_code = true;
                    if(selVal.trim().toLowerCase() == 'account number') that.mand_account_number = true;*/
                    if(selVal.trim().toLowerCase() == 'income tax') that.mand_tax = true;
                    if(selVal.trim().toLowerCase() == 'basic salary') that.mand_basic_salary = true;
                    if(selVal.trim().toLowerCase() == 'net payable') that.mand_net_payable = true;
                });
            },
            assignComboFunction(){
                var that = this;
                // Auto Mapped value make disabled
                $('select.selectpicker').each(function(index,obj){
                    if(obj.value.toLowerCase() !== 'other allowance' && obj.value.toLowerCase() !== 'other additional earning' && obj.value.toLowerCase() !== 'other deductions' && obj.value.toLowerCase() !== 'reimbursements'){
                        console.log(obj.value);
                        $('select.selectpicker option[value="'+obj.value+'"]').attr('disabled',true);
                    }
                });
                $(that.$el).find('.selectpicker').selectpicker('refresh');
                var previous;
                $('select.selectpicker').on('shown.bs.select',function(){
                    previous = this.value;
                }).change(function(){
                    var selVal = $(this).find('option:selected').val();
                    if(previous.toLowerCase() !== 'other allowance' && previous.toLowerCase() !== 'other additional earning' && previous.toLowerCase() !== 'other deductions' && previous.toLowerCase() !== 'reimbursements'){
                        $('select.selectpicker option[value="'+previous+'"]').attr('disabled',false);
                    }
                    //hide the department, branch and city field sets if deselect
                    if(previous.toLowerCase() == 'department'){
                        $('div.departmentTable').remove();
                        $('table.departmentTable').remove();
                    }
                    if(previous.toLowerCase() == 'category'){
                        $('div.categoryTable').remove();
                        $('table.categoryTable').remove();
                    }
                    if(previous.toLowerCase() == 'city'){
                        $('div.cityTable').remove();
                        $('table.cityTable').remove();
                    }
                    if(previous.toLowerCase() == 'branch'){
                        $('div.branchTable').remove();
                        $('table.branchTable').remove();
                    }
                    
                    if(selVal.toLowerCase() !== 'other allowance' && selVal.toLowerCase() !== 'other additional earning' && selVal.toLowerCase() !== 'other deductions' && selVal.toLowerCase() !== 'reimbursements'){
                        $('select.selectpicker option[value="'+selVal+'"]').attr('disabled',true);
                    }
                    $(that.$el).find('.selectpicker').selectpicker('refresh');

                    var flag = false;
                    that.checkForMandField();
                    if(selVal.trim().toLowerCase() == 'department'){
                        that.mand_department = true;
                        that.departmentMapped = that.departmentCount = 0;
                        that.finalDepartmentArray = [];
                        that.showFieldInIdentifiers('department',that.fileRowData,$(this).attr('name'));
                    }
                    if(selVal.trim().toLowerCase() == 'city'){
                        that.mand_city = true;
                        that.cityMapped = that.cityCount = 0;
                        that.finalcityArray = [];
                        that.showFieldInIdentifiers('city',that.fileRowData,$(this).attr('name'));
                    }
                    if(selVal.trim().toLowerCase() == 'branch'){
                        that.mand_branch = true;
                        that.branchMapped = that.branchCount = 0;
                        that.finalBranchArray = [];
                        that.showFieldInIdentifiers('branch',that.fileRowData,$(this).attr('name'));
                    }

                    that.generateButtonProccess();
                });
            },
            showFieldInIdentifiers(datafor,fileRowData,itemIndex){
                var dataTableFor = '';
                var mappingfor = '';
                if(datafor == 'department'){
                    mappingfor = '<h3>We\'ve found some new departments.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'departmentTable';
                }
                if(datafor == 'city'){
                    mappingfor = '<h3>We\'ve found some new cities.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'cityTable';
                }
                if(datafor == 'category'){
                    mappingfor = '<h3>We\'ve found some new categories.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'categoryTable';
                }
                if(datafor == 'branch'){
                    mappingfor = '<h3>We\'ve found some new branches.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'branchTable';
                }
                var html = mappingfor;
                if(datafor == 'department'){
                    var departmentArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var department = data[itemIndex];
                        if(departmentArray.indexOf(department) == -1){
                            departmentArray.push(department);
                        }
                    }
                    this.departmentCount = departmentArray.length;
                    for(var k = 0; k < this.departmentCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultDepartment = 'Select department';
                        for(var t=0; t < this.departmentLi.length; t++){
                            if(this.departmentLi[t].label.toLowerCase() == departmentArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultDepartment = this.departmentLi[t].label;
                                this.finalDepartmentArray.push({id:this.departmentLi[t].value,name:departmentArray[k]});
                                this.departmentMapped = this.finalDepartmentArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="catory-value department"><a class="dropdown-link" href="javascript:void(0)" onclick="mapDepartmentSelection(\''+this.departmentLi[t].value+'\',\''+departmentArray[k]+'\',this);">'+this.departmentLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                        html += '<div class="col-md-8">';
                        html += '<strong class="title">'+departmentArray[k]+'</strong>';
                        html += '</div>';
                        html += '<div class="col-md-4">';
                        html += '<div class="dropdown">';
                        html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select Department<span class="caret"></span></a>';
                        html += '<div class="dropdown-menu add-category-dropdown">';
                        html += '<ul class="department_list list">';
                        html += li;
                        html += '</ul>';
                        html += '<div class="add-department"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addDepartment"><i class="fas fa-plus"></i> Add Department</button></div>';
                        html += '</div>';
                        html += '</div>';
                        html += '</div>';
                        html += '</div>';
                    }
                }
                if(datafor == 'category'){
                    var categoryArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var category = data[itemIndex];
                        if(categoryArray.indexOf(category) == -1){
                            categoryArray.push(category);
                        }
                    }
                    this.categoryCount = categoryArray.length;
                    for(var k = 0; k < this.categoryCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultCategory = 'Select Category';
                        for(var t=0; t < this.categoryLi.length; t++){
                            if(this.categoryLi[t].label.toLowerCase() == categoryArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultCategory = this.categoryLi[t].label;
                                this.finalcategoryArray.push({id:this.categoryLi[t].value,name:categoryArray[k]});
                                this.categoryMapped = this.finalcategoryArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="catory-value category"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCategorySelection(\''+this.categoryLi[t].value+'\',\''+categoryArray[k]+'\',this);">'+this.categoryLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                        html += '<div class="col-md-8">';
                        html += '<strong class="title">'+categoryArray[k]+'</strong>';
                        html += '</div>';
                        html += '<div class="col-md-4">';
                        html += '<div class="dropdown">';
                        html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select Category<span class="caret"></span></a>';
                        html += '<div class="dropdown-menu add-category-dropdown">';
                        html += '<ul class="category_list list">';
                        html += li;
                        html += '</ul>';
                        html += '<div class="add-category"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addCategory"><i class="fas fa-plus"></i> Add Category</button></div>';
                        html += '</div>';
                        html += '</div>';
                        html += '</div>';
                        html += '</div>';
                    }
                }
                if(datafor == 'city'){
                    var cityArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var city = data[itemIndex];
                        if(cityArray.indexOf(city) == -1){
                            cityArray.push(city);
                        }
                    }
                    this.cityCount = cityArray.length;
                    for(var k = 0; k < this.cityCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultCity = 'Select City';
                        for(var t=0; t < this.cityLi.length; t++){
                            if(this.cityLi[t].label.toLowerCase() == cityArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultCity = this.cityLi[t].label;
                                this.finalcityArray.push({id:this.cityLi[t].value,name:cityArray[k]});
                                this.cityMapped = this.finalcityArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="catory-value city"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCitySelection(\''+this.cityLi[t].value+'\',\''+cityArray[k]+'\',this);">'+this.cityLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                        html += '<div class="col-md-8">';
                        html += '<strong class="title">'+cityArray[k]+'</strong>';
                        html += '</div>';
                        html += '<div class="col-md-4">';
                        html += '<div class="dropdown">';
                        html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select City<span class="caret"></span></a>';
                        html += '<div class="dropdown-menu add-category-dropdown">';
                        html += '<ul class="city_list list">';
                        html += li;
                        html += '</ul>';
                        html += '<div class="add-city"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addCity"><i class="fas fa-plus"></i> Add City</button></div>';
                        html += '</div>';
                        html += '</div>';
                        html += '</div>';
                        html += '</div>';
                    }
                }
                if(datafor == 'branch'){
                    var branchArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var branch = data[itemIndex];
                        if(branchArray.indexOf(branch) == -1){
                            branchArray.push(branch);
                        }
                    }
                    this.branchCount = branchArray.length;
                    for(var k = 0; k < this.branchCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultBranch = 'Select Branch';
                        for(var t=0; t < this.branchLi.length; t++){
                            if(this.branchLi[t].label.toLowerCase() == branchArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultBranch = this.branchLi[t].label;
                                this.finalBranchArray.push({id:this.branchLi[t].value,name:branchArray[k]});
                                this.branchMapped = this.finalBranchArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="catory-value branch"><a class="dropdown-link" href="javascript:void(0)" ' +
                                'onclick="mapBranchSelection(\''+this.branchLi[t].value+'\',\''+branchArray[k]+'\',this);">'+this.branchLi[t].label+'' +
                                '</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                        html += '<div class="col-md-8">';
                        html += '<strong class="title">'+branchArray[k]+'</strong>';
                        html += '</div>';
                        html += '<div class="col-md-4">';
                        html += '<div class="dropdown">';
                        html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select Branch<span class="caret"></span></a>';
                        html += '<div class="dropdown-menu add-category-dropdown">';
                        html += '<ul class="branch_list list">';
                        html += li;
                        html += '</ul>';
                        html += '<div class="add-branch"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addBranch"><i class="fas fa-plus"></i> Add Branch</button></div>';
                        html += '</div>';
                        html += '</div>';
                        html += '</div>';
                        html += '</div>';
                    }
                }
                $('div.need-attention-content').append(html);
                this.customCombo();
            },
            customCombo(){
                // for c-val-displayer start
                $(".cstm-cmbx-w-adtn .c-val-displayer").unbind('click').click(function(){
                    var ref = $(this);
                    var popDiv =  $(this).parent().find(".val-overlyr");
                    var popper = new Popper(ref,popDiv,{
                        placement:'bottom-end',
                        gpuAcceleration:false
                    });
                    $(this).parent().find(".val-overlyr").toggleClass("activated");
                });
                // for c-val-displayer end
            },
            checkFileForErrors(file){
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    var col = [];
                    var duplicate = false;
                    var column = false;
                    var duplicateArray = [];
                    for(var row in data) {
                        if(row == 0){
                            for(var item in data[row]) {
                                var value = data[row][item];
                                value = value.replace(/[^\w\s]/gi,'');
                                if(col.indexOf(value) > -1){
                                    duplicate = true;
                                    duplicateArray.push(value);
                                }
                                col.push(value);
                            }
                        }else{
                            break;
                        }
                    }
                    if(duplicate == true && that.fileAdded == true){
                        var error_message = $('div#duplicatemessage').html() + duplicateArray.toString();
                        that.showAlertBox('error','Duplicate column name',error_message);
                    }
                    if(col.length < 3 && that.fileAdded == true){
                        column = true;
                        var error_message = $('div#columnfourmessage').html();
                        that.showAlertBox('error','Missing column',error_message);
                    }
                    if(duplicate == true || column == true){
                        that.dropZoneObject.removeAllFiles();
                    }
                };
                reader.onerror = function(){ this.showAlertBox('Unable to read ' + file.fileName); }.bind(this);
            },
            saveDepartment(){
                var departmentValue = $('#departmentAddValue').val();
                if (departmentValue === "") {
                    that.showAlertBox('error','Please enter department name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    axios.post('/api/addDepartment',{name:departmentValue})
                        .then(response => {
                            if(response.status == 200){
                                that.finalDepartmentArray.push({id:response.data.department_id,name:departmentValue});
                                that.departmentMapped = that.finalDepartmentArray.length;
                                var html = '<li class="catory-value"><a class="dropdown-link" href="javascript:void(0)" onclick="mapDepartmentSelection(\''+response.data.department_id+'\',\''+departmentValue+'\',this);">'+departmentValue+'</a></li>';
                                $('ul.department_list').find('li:last').each(function(){
                                    $(this).after(html);
                                });
                                $("#addDepartment").modal("hide");
                                that.showToastBox('success','Department has been added');
                                that.$Progress.finish();
                            }else{
                                that.showAlertBox('error','Something went wrong');
                                that.$Progress.fail();
                            }
                        });
                }
            },
            saveCategory(){
                var categoryValue = $('#categoryAddValue').val();
                if (categoryValue === "") {
                    that.showAlertBox('error','Please enter category name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    axios.post('/api/addCategory',{name:categoryValue})
                        .then(response => {
                            if(response.status == 200){
                                that.finalcategoryArray.push({id:response.data.category_id,name:categoryValue});
                                that.categoryMapped = that.finalcategoryArray.length;
                                var html = '<li class="catory-value"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCategorySelection(\''+response.data.category_id+'\',\''+categoryValue+'\',this);">'+categoryValue+'</a></li>';
                                $('ul.category_list').find('li:last').each(function(){
                                    $(this).after(html);
                                });
                                $("#addCategory").modal("hide");
                                that.showToastBox('success','Category has been added');
                                that.$Progress.finsih();
                            }else{
                                that.showAlertBox('error','Something went wrong');
                                that.$Progress.fail();
                            }
                        });
                }
            },
            saveCity(){
                var cityValue = $('#cityAddValue').val();
                if (cityValue === "") {
                    that.showAlertBox('error','Please enter city name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    axios.post('/api/addCity',{name:cityValue})
                        .then(response => {
                            if(response.status == 200){
                                that.finalcityArray.push({id:response.data.city_id,name:cityValue});
                                that.cityMapped = that.finalcityArray.length;
                                var html = '<li class="catory-value"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCitySelection(\''+response.data.city_id+'\',\''+cityValue+'\',this);">'+cityValue+'</a></li>';
                                $('ul.city_list').find('li:last').each(function(){
                                    $(this).after(html);
                                });
                                $("#addCategory").modal("hide");
                                that.showToastBox('success','City has been added');
                                that.$Progress.finsih();
                            }else{
                                that.showAlertBox('error','Something went wrong');
                                that.$Progress.fail();
                            }
                        });
                }
            },
            saveBranch(){
                var branchValue = $('#branchAddValue').val();
                if (branchValue === "") {
                    that.showAlertBox('error','Please enter branch name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    axios.post('/api/addBranch',{name:branchValue})
                        .then(response => {
                            if(response.status == 200){
                                that.finalBranchArray.push({id:response.data.branch_id,name:branchValue});
                                that.branchMapped = that.finalBranchArray.length;
                                var html = '<li class="catory-value"><a class="dropdown-link" href="javascript:void(0)" onclick="mapBranchSelection(\''+response.data.branch_id+'\',\''+branchValue+'\',this);">'+branchValue+'</a></li>';
                                $('ul.branch_list').find('li:last').each(function(){
                                    $(this).after(html);
                                });
                                $("#addCategory").modal("hide");
                                that.showToastBox('success','Branch has been added');
                                that.$Progress.finsih();
                            }else{
                                that.showAlertBox('error','Something went wrong');
                                that.$Progress.fail();
                            }
                        });
                }
            },
            generatePayrollData(){
                var that = this;
                if(that.$route.query.payroll_id != null)
                {
                    that.payroll_id = that.$route.query.payroll_id;
                }
                this.$Progress.start();
                axios.post("/api/generatePayroll",{
                    payroll_id:that.payroll_id
                })
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            that.companyType = res.data.companyType;
                            that.company = res.data.company;
                            that.payroll = res.data.payroll;
                            that.payrollType = res.data.payrollType;
                            res.data.departments.forEach(dept => {
                            that.departmentLi.push({value:dept.id,label:dept.name});
                            });
                            res.data.branches.forEach(branch => {
                            that.branchLi.push({value:branch.id,label:branch.name});
                            });
                            res.data.cities.forEach(city => {
                            that.cityLi.push({value:city.id,label:city.name});
                            });

                            if(that.payroll != null){
                                that.title = that.payroll.name;
                                that.payroll_type = that.payroll.payroll_type;
                                that.payroll_frequency = that.payroll.payroll_frequency;
                                if(that.payroll.payroll_frequency == 'ONETIME'){
                                    that.onetime_date = that.payroll.onetime_date;
                                }else{
                                    that.from_date = that.payroll.from_date;
                                    that.to_date = that.payroll.to_date;
                                }
                            }

                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },

        },
        created() {
        },
        mounted(){
            var that = this;
            this.initDropZone();
            $(".drozone-label").tooltip({
                html	: true,
                template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner large"></div></div>',
                offset: '60'
            });
            $("#drop").dropzone();

            /*$('.datepicker').datepicker({
                format: 'yyyy-mm-dd',
                endDate: '+0d',
                autoHide: true
            });*/
            this.$Progress.start();
            this.can('create_payroll_batch').then(result => {
                this.create_payroll_batch = result.create_payroll_batch;
            }).then(result => {
                if(this.create_payroll_batch == true){
                    this.generatePayrollData();
                    window.mapDepartmentSelection = function(id,value,obj){
                        $(obj).parent().find("li.department").removeClass("row-enabled");
                        $(obj).addClass('row-enabled');
                        var valueExist = false;
                        for(var index in that.finalDepartmentArray){
                            if(that.finalDepartmentArray[index].name.toLowerCase() == value.toLowerCase()){
                                that.finalDepartmentArray.splice(index,1);
                                that.finalDepartmentArray.push({id:id,name:value});
                                valueExist = true;
                                break;
                            }
                        }
                        if(valueExist === false){
                            that.finalDepartmentArray.push({id:id,name:value});
                        }
                        that.departmentMapped = that.finalDepartmentArray.length;
                        that.generateButtonProccess();
                    }
                    window.mapCategorySelection = function(id,value,obj){
                        $(obj).parent().find("li.category").removeClass("row-enabled");
                        $(obj).addClass('row-enabled');
                        var valueExist = false;
                        for(var index in that.finalcategoryArray){
                            if(that.finalcategoryArray[index].name.toLowerCase() == value.toLowerCase()){
                                that.finalcategoryArray.splice(index,1);
                                that.finalcategoryArray.push({id:id,name:value});
                                valueExist = true;
                                break;
                            }
                        }
                        if(valueExist === false){
                            that.finalcategoryArray.push({id:id,name:value});
                        }
                        that.categoryMapped = that.finalcategoryArray.length;
                        that.generateButtonProccess();
                    }
                    window.mapCitySelection = function(id,value,obj){
                        $(obj).parent().find("li.city").removeClass("row-enabled");
                        $(obj).addClass('row-enabled');
                        var valueExist = false;
                        for(var index in that.finalcityArray){
                            if(that.finalcityArray[index].name.toLowerCase() == value.toLowerCase()){
                                that.finalcityArray.splice(index,1);
                                that.finalcityArray.push({id:id,name:value});
                                valueExist = true;
                                break;
                            }
                        }
                        if(valueExist === false){
                            that.finalcityArray.push({id:id,name:value});
                        }
                        that.cityMapped = that.finalcityArray.length;
                        that.generateButtonProccess();
                    }
                    window.mapBranchSelection = function(id,value,obj){
                        $(obj).parent().find("li.branch").removeClass("row-enabled");
                        $(obj).addClass('row-enabled');
                        var valueExist = false;
                        for(var index in that.finalBranchArray){
                            if(that.finalBranchArray[index].name.toLowerCase() == value.toLowerCase()){
                                that.finalBranchArray.splice(index,1);
                                that.finalBranchArray.push({id:id,name:value});
                                valueExist = true;
                                break;
                            }
                        }
                        if(valueExist === false){
                            that.finalBranchArray.push({id:id,name:value});
                        }
                        that.branchMapped = that.finalBranchArray.length;
                        that.generateButtonProccess();
                    }
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        }
    }
</script>

